import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

import {store} from './store';

import Meta from './js/Meta.js';

import Index from './vue_pages/Index.vue';
import E404 from './vue_pages/E404.vue'
import E403 from './vue_pages/E403.vue'

import Profile from './vue_pages/Profile/Index.vue'
import ProfileInfo from './vue_pages/Profile/Profile.vue'
import MyCourses from './vue_pages/Profile/MyCourses.vue'
import MyEntries from './vue_pages/Profile/MyEntries.vue'
import Finance from './vue_pages/Profile/Finance.vue'
import Documents from './vue_pages/Profile/Documents.vue'
import MyInfo from './vue_pages/Profile/MyInfo.vue'
import Settings from './vue_pages/Profile/Settings.vue'
import PasswordReset from './vue_pages/Profile/PasswordReset.vue'
import BlackList from './vue_pages/Profile/BlackList.vue'

import Courses from './vue_pages/Courses/Index.vue'
import CoursesView from './vue_pages/Courses/View/Index.vue'
import CoursesViewInfo from './vue_pages/Courses/View/View.vue'
import CoursesEdit from './vue_pages/Courses/View/Edit.vue'
import CoursesApplications from './vue_pages/Courses/View/Applications.vue'
import CoursesCreate from './vue_pages/Courses/Create.vue'
import History from './vue_pages/Courses/View/History.vue'
import Reviews from './vue_pages/Courses/View/Reviews.vue'

import User from './vue_pages/User/Index.vue'
import Notice from './vue_pages/Notice/Index.vue'
import Dialog from './vue_pages/Dialog/Index.vue'

import About from './vue_pages/About/Index.vue'
import TermsService from './vue_pages/TermsService/Index.vue'
import Faq from './vue_pages/Faq/Index.vue'
import Contacts from './vue_pages/Contacts/Index.vue'

import reload from './vue_pages/reload.vue'

import Articles from './vue_pages/Articles/Index.vue'
import ArticlesView from './vue_pages/Articles/View.vue'

const routes = [
    {
        path: '',
        name: 'home',
        component: Index,
        meta: {
            requiresAuth: false,
            title: '«Эй, Ньютон!» — Исключительно современный ум'
        }
    },
    {
        path: '/courses',
        name: 'courses',
        component: Courses,
        meta: {
            requiresAuth: false,
            title: '«Эй, Ньютон!» — Уроки, курсы и консультации'
        }
    },
    {
        path: '/courses/create',
        name: 'courses_create',
        component: CoursesCreate,
        meta: {
            requiresAuth: true,
            title: '«Эй, Ньютон!» — Создание курса'
        }
    },
    {
        path: '/courses/:id/:slug',
        component: CoursesView,
        props: { id: null},
        children: [
            {
                path: '',
                name: 'courses_info',
                component: CoursesViewInfo,
                meta: {
                    requiresAuth: false,
                    title: '«Эй, Ньютон!» — Описание курса'
                }
            },
            {
                path: 'edit',
                name: 'courses_edit',
                component: CoursesEdit,
                meta: {
                    requiresAuth: true,
                    title: '«Эй, Ньютон!» — Редактирование курса'
                }
            },
            {
                path: 'applications',
                name: 'courses_applications',
                component: CoursesApplications,
                meta: {
                    requiresAuth: true,
                    title: '«Эй, Ньютон!» — Заявки курса'
                },
                query: {
                    date: null,
                }
            },
            {
                path: 'history',
                name: 'courses_history',
                component: History,
                meta: {
                    requiresAuth: true,
                    title: '«Эй, Ньютон!» — история'
                }
            },
            {
                path: 'reviews',
                name: 'reviews',
                component: Reviews,
                meta: {
                    requiresAuth: false,
                    title: '«Эй, Ньютон!» — отзывы'
                }
            }
        ],
        meta: {
            requiresAuth: false,
            title: '«Эй, Ньютон!» — Уроки, курсы и консультации'
        }
    },
    {
        path: '/users',
        redirect: {name: 'home'}
    },
    {
        path: '/about',
        name: 'about',
        component: About,
        meta: {
            requiresAuth: false,
            title: '«Эй, Ньютон!» — О сервисе'
        }
    },
    {
        path: '/terms_service',
        name: 'terms_service',
        component: TermsService,
        meta: {
            requiresAuth: false,
            title: '«Эй, Ньютон!» — Правила сервиса'
        }
    },
    {
        path: '/faq',
        name: 'faq',
        component: Faq,
        meta: {
            requiresAuth: false,
            title: '«Эй, Ньютон!» — Частые вопросы'
        }
    },
    {
        path: '/contacts',
        name: 'contacts',
        component: Contacts,
        meta: {
            requiresAuth: false,
            title: '«Эй, Ньютон!» — Контакты'
        }
    },
    {
        path: '/profile',
        component: Profile,
        meta: {
            requiresAuth: true,
            title: '«Эй, Ньютон!» — Личный кабинет'
        },
        children: [
            {
                path: '',
                name: 'profileInfo',
                component: ProfileInfo,
                meta: {
                    requiresAuth: true,
                    title: '«Эй, Ньютон!» — Личный кабинет'
                }
            },
            {
                path: 'my_courses',
                name: 'my_courses',
                component: MyCourses,
                meta: {
                    requiresAuth: true,
                    title: '«Эй, Ньютон!» — Я учу'
                }
            },
            {
                path: 'my_entries',
                name: 'my_entries',
                component: MyEntries,
                meta: {
                    requiresAuth: true,
                    title: '«Эй, Ньютон!» — Я учусь'
                }
            },
            {
                path: 'documents',
                name: 'documents',
                component: Documents,
                meta: {
                    requiresAuth: true,
                    title: '«Эй, Ньютон!» — Документы'
                }
            },
            {
                path: 'my_info',
                name: 'my_info',
                component: MyInfo,
                meta: {
                    requiresAuth: true,
                    title: '«Эй, Ньютон!» — Мои данные'
                }
            },
            {
                path: 'settings',
                name: 'settings',
                component: Settings,
                meta: {
                    requiresAuth: true,
                    title: '«Эй, Ньютон!» — Настройки'
                }
            },
            {
                path: 'black_list',
                name: 'black_list',
                component: BlackList,
                meta: {
                    requiresAuth: true,
                    title: '«Эй, Ньютон!» — Черный список'
                }
            }
        ]
    },
    {
        path: '/profile/finance',
        name: 'finance',
        component: Finance,
        meta: {
            requiresAuth: true,
            title: '«Эй, Ньютон!» — Финансы'
        },
        query: {
            pages: 1
        }
    },
    {
        path: '/profile/password_reset',
        name: 'password_reset',
        query: { token: null},
        component: PasswordReset,
        meta: {
            requiresAuth: false,
            title: '«Эй, Ньютон!» — Сброс пароля'
        }
    },
    {
        path: '/users/:url',
        name: 'user',
        component: User,
        props: { url: null},
        meta: {
            requiresAuth: false,
            title: '«Эй, Ньютон!» — Уроки, курсы и консультации'
        }
    },
    {
        path: '/notice',
        name: 'notice',
        component: Notice,
        meta: {
            requiresAuth: true,
            title: '«Эй, Ньютон!» — Уведомления'
        }
    },
    {
        path: '/dialog',
        name: 'dialog',
        component: Dialog,
        meta: {
            requiresAuth: true,
            title: '«Эй, Ньютон!» — Диалоги'
        },
        query: {
            sel: 'all'
        }
    },
    // {
    //     path: '/articles',
    //     name: 'articles',
    //     component: Articles,
    //     meta: {
    //         requiresAuth: false,
    //         title: '«Эй, Ньютон!» — Статьи'
    //     }
    // },
    // {
    //     path: '/articles/:id/:slug',
    //     name: 'articles_view',
    //     component: ArticlesView,
    //     meta: {
    //         requiresAuth: false,
    //         title: '«Эй, Ньютон!» — Статьи'
    //     }
    // },
    {
        path: '/reload',
        name: 'reload',
        component: reload,
        meta: {
            requiresAuth: false,
            title: '«Эй, Ньютон!»'
        }
    },
    {
        path: '/404',
        component: E404,
        name: 'E404',
        meta: {
            requiresAuth: false,
            title: 'Нет такой страницы :('
        }
    },
    {
        path: '/403',
        component: E403,
        name: 'E403',
        meta: {
            requiresAuth: false,
            title: 'Нет такой страницы :('
        }
    },
    {
        path: '*',
        component: E404,
        meta: {
            requiresAuth: false,
            title: 'Нет такой страницы :('
        }
    }
];

export const router = new VueRouter({
    routes,
    base: '/',
    mode: 'history',
    scrollBehavior (to, from, savedPosition) {
        if((to.name !== from.name)){
            if (savedPosition) {
                return savedPosition
            } else {
                return { x: 0, y: 0 }
            }
        } else{
            if(to.params.id){
                if(to.params.id !== from.params.id){
                    if (savedPosition) {
                        return savedPosition
                    } else {
                        return { x: 0, y: 0 }
                    }
                }
            }
        }
    }
});

router.beforeEach((to, from, next) => {
    store.dispatch('menuClose');

    if(!store.getters['load'] && to.name !== 'home'){
        store.dispatch('Loading');
    }

    let count = 0;
    store.dispatch('locale/LoadLocale').then(()=>{
        // store.dispatch('handbook/LoadFieldKnowledgee').then(() => {
        //     count++;
        //     RunNext();
        // });

        // store.dispatch('handbook/LoadInterestingTopics').then(() => {
        //     count++;
        //     RunNext();
        // });

        store.dispatch('handbook/LoadSocials').then(() => {
            count++;
            RunNext();
        });

        store.dispatch('staticText/LoadDefaultText').then(() => {
            count++;
            RunNext();
        });
    });



    let RunNext = () => {
        if(count > 1){
            store.dispatch('profile/HasAuth').then((e) => {
                if (to.matched.some(record => record.meta.requiresAuth) && to.name !== 'password_reset') {
                    if (!store.getters['profile/hasAuth']) {
                        next({
                            name: 'E403'
                        })
                    }
                }
                if(e)
                    next(store.dispatch('msg/showMsg', e));
                else
                    next();
            });
        }
    }
});

router.afterEach((to, from) => {
    if (store.state.meta.items[to.path] == undefined){
        store.dispatch('meta/loadItems', to).then(()=>{
            Meta(store, to);
        });
    } else {
        Meta(store, to);
    }
});


// WEBPACK FOOTER //
// ./src/routes.js